import React from 'react'
import { useSelector } from 'react-redux'
import { HIDE_CANNED_REPLY_PREVIEW_CALLOUT } from 'ducks/flags/flagNames'
import { selectFlag } from 'ducks/flags'
import PreviewCallout from './PreviewCallout'

const WithPreviewCallout = ({ children }) => {
  const shouldHide = useSelector(state =>
    selectFlag(state)(HIDE_CANNED_REPLY_PREVIEW_CALLOUT)
  )
  if (shouldHide !== false) return children
  return <PreviewCallout>{children}</PreviewCallout>
}

export default WithPreviewCallout
